import { types, getParent, Instance } from 'mobx-state-tree'
import { Project } from 'src/api/models/Project'

interface TotalProperty {
  values: { label: string; property: $FixMe }[]
  total: number
}

export const Total = () =>
  types
    .model('Total', {
      active: types.optional(types.boolean, false)
    })
    .views(self => {
      const project = getParent<any>(self, 1).draft as Instance<ReturnType<typeof Project>>
      const {
        width,
        thickness,
        length,
        componentSide,
        solderSide
      } = project.content.edges[0].node.properties
      const {
        gap: { front, top, left, right, bottom, back }
      } = project.content.edges[0].properties
      const total = {
        width: length.value + left.value + right.value,
        height:
          thickness.value +
          componentSide.height.value +
          solderSide.height.value +
          top.value +
          bottom.value,
        depth: width.value + front.value + back.value
      }
      return {
        get width() {
          return {
            values: [
              { label: 'pcb length', property: length },
              { label: 'gap left ', property: left },
              { label: 'gap right', property: right }
            ],
            total: total.width
          }
        },
        get height(): TotalProperty {
          return {
            values: [
              { label: 'pcb thickness', property: thickness },
              { label: 'pcb component side height', property: componentSide.height },
              { label: 'pcb solder side height', property: solderSide.height },
              { label: 'gap top', property: top },
              { label: 'gap bottom', property: bottom }
            ],
            total: total.height
          }
        },
        get depth() {
          return {
            values: [
              { label: 'pcb width', property: width },
              { label: 'gap front', property: front },
              { label: 'gap back', property: back }
            ],
            total: { value: total.depth, min: 20, max: 500 }
          }
        }
      }
    })
